/* ========================================
   CART DRAWER - from Lovable CartDrawer.tsx
   Listens to cart:open, AJAX qty/remove via Shopify Cart API
   ======================================== */

(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-body]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
    var moneyFormat = (window.SYNC && window.SYNC.formatMoney) ? null : null;

    /* ---------- Open / close ---------- */
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refresh();
      renderLines();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('cart:open', open);
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* ---------- Order note (optional) ---------- */
    var noteEl = drawer.querySelector('[data-cart-note]');
    if (noteEl) {
      noteEl.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        }).catch(function () {});
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* ---------- Money formatting (Shopify) ---------- */
    function formatMoney(cents) {
      if (window.SYNC && window.SYNC.formatMoneyShop) return window.SYNC.formatMoneyShop(cents);
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    /* ---------- Refresh from /cart.js + re-render section ---------- */
    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCounts(cart.item_count);
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
        });
    }

    function updateCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }

    /* ---------- Re-render line items via Section Rendering API ---------- */
    function rerenderContents() {
      // Use cart contents snippet through a section render
      fetch('/?section_id=cart-drawer-render')
        .then(function (r) { return r.text(); })
        .catch(function () { return null; });
      // Simpler: refetch full page fragment for the contents snippet
      fetch(window.location.pathname + '?_=' + Date.now())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          if (fresh && body) body.innerHTML = fresh.innerHTML;
          bindLineActions();
        });
    }

    /* ---------- Change line quantity ---------- */
    function changeLine(key, qty) {
      body.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCounts(cart.item_count);
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
          return renderLines();
        })
        .then(function () {
          body.classList.remove('is-loading');
        })
        .catch(function () { body.classList.remove('is-loading'); });
    }

    /* ---------- Render lines via Cart Section API ---------- */
    function renderLines() {
      return fetch('/cart?section_id=cart-drawer-section')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) { return fallbackRender(); }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          if (fresh && body) { body.innerHTML = fresh.innerHTML; bindLineActions(); }
          else { return fallbackRender(); }
        });
    }

    function fallbackRender() {
      return fetch(window.location.pathname)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          if (fresh && body) { body.innerHTML = fresh.innerHTML; bindLineActions(); }
        });
    }

    /* ---------- Bind qty +/- and remove ---------- */
    function bindLineActions() {
      body.querySelectorAll('[data-qty-up]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-item]');
          var key = btn.getAttribute('data-line-key');
          var val = parseInt(line.querySelector('[data-qty-val]').textContent, 10);
          changeLine(key, val + 1);
        });
      });
      body.querySelectorAll('[data-qty-down]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-item]');
          var key = btn.getAttribute('data-line-key');
          var val = parseInt(line.querySelector('[data-qty-val]').textContent, 10);
          changeLine(key, Math.max(0, val - 1));
        });
      });
      body.querySelectorAll('[data-line-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-key');
          changeLine(key, 0);
        });
      });
    }

    /* ---------- Discount collapsible ---------- */
    var discountToggle = drawer.querySelector('[data-discount-toggle]');
    var discountPanel = drawer.querySelector('[data-discount-panel]');
    if (discountToggle && discountPanel) {
      discountToggle.addEventListener('click', function () {
        var isOpen = !discountPanel.hidden;
        discountPanel.hidden = isOpen;
        discountToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        discountToggle.classList.toggle('is-open', !isOpen);
      });
    }

    /* ---------- Listen for add-to-cart events globally ---------- */
    document.addEventListener('cart:refresh', function () {
      refresh();
      renderLines();
    });
    document.addEventListener('cart:added', function () {
      open();
    });

    bindLineActions();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
